import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'María José',
  city: 'Ciudad de México',
  country: 'México'
}, {
  name: 'Florencia',
  city: 'Buenos Aires',
  country: 'Argentina'
}, {
  name: 'Camila',
  city: 'Montevideo',
  country: 'Uruguay'
}, {
  name: 'Javiera',
  city: 'Santiago',
  country: 'Chile'
}, {
  name: 'Liliana',
  city: 'Asunción',
  country: 'Paraguay'
}, {
  name: 'Valeria',
  city: 'Guadalajara',
  country: 'México'
}, {
  name: 'Sofía',
  city: 'Córdoba',
  country: 'Argentina'
}, {
  name: 'Daniela',
  city: 'Bogotá',
  country: 'Colombia'
}, {
  name: 'Andrea',
  city: 'Lima',
  country: 'Perú'
}, {
  name: 'Romina',
  city: 'Rosario',
  country: 'Argentina'
}, {
  name: 'Carla',
  city: 'Viña del Mar',
  country: 'Chile'
}, {
  name: 'Gabriela',
  city: 'Quito',
  country: 'Ecuador'
}, {
  name: 'Luciana',
  city: 'Monterrey',
  country: 'México'
}, {
  name: 'Paula',
  city: 'Salto',
  country: 'Uruguay'
}, {
  name: 'Mariana',
  city: 'San José',
  country: 'Costa Rica'
}];
export function PurchasePopup() {
  const [currentBuyer, setCurrentBuyer] = useState<(typeof buyers)[0] | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showRandomBuyer = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialTimer = setTimeout(showRandomBuyer, 10000);
    const interval = setInterval(() => {
      if (!isVisible) {
        setTimeout(showRandomBuyer, Math.random() * 15000 + 20000);
      }
    }, 35000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-255">
      {isVisible && currentBuyer && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-2xl border border-stone-100 p-4 flex items-center gap-4 max-w-sm" data-id="element-256">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-257">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-258" />
          </div>
          <div data-id="element-259">
            <p className="text-sm text-stone-600" data-id="element-260">Alguien acaba de comprar</p>
            <p className="font-bold text-violet-900" data-id="element-261">{currentBuyer.name}</p>
            <div className="flex items-center gap-1 text-xs text-stone-500 mt-1" data-id="element-262">
              <MapPin className="w-3 h-3" data-id="element-263" />
              <span data-id="element-264">
                {currentBuyer.city}, {currentBuyer.country}
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}